<template>
  <div class="IT-box" v-if="isShow">
    <a href="https://www.dellemc-solution.com/campaign/coupon/box?id=7" rel="noreferrer" target="_blank">
      <img src="https://www.dellemc-solution.com/campaigns/xcx_images/dell-solution-services-miniprogram/integral/fixed-coupon-box.png" class="img-IT" alt="">
    </a>
    <a href="https://www.dellemc-solution.com/solutioncatalog/" rel="noreferrer" target="_blank">
      <img src="https://www.dellemc-solution.com/campaigns/xcx_images/dell-solution-services-miniprogram/integral/fixed-download-file.png" class="img-IT" alt="">
    </a>
    <img src="https://www.dellemc-solution.com/campaigns/xcx_images/dell-solution-services-miniprogram/integral/icon-close3.png"
         class="img-icon" alt="" @click="closeIT">
  </div>
</template>
<script>
export default {
  name: "ITSubscribe",
  data(){
    return{
      isShow: true
    }
  },
  mounted() {
    this.onScroll();
  },
  methods:{
    closeIT(){
      this.isShow = false;
    },
    toIT(){
      window.location.href="https://www.dellemc-solution.com/campaign/jump-xcx?path=pages%2Fintegral%2Findex&query=pos%3Dmodule-item-5";
    },
    onScroll(){
      let timer = null;
      window.addEventListener('scroll', () => {
        clearTimeout(timer);
        $('.IT-box').addClass('IT-option');
        timer = setInterval(function () {
          $('.IT-box').removeClass('IT-option');
        },500);
      })
    }
  }
}
</script>
<style scoped lang="scss">
.IT-option{opacity: .5}
.IT-box{
  width: 2rem;
  position: fixed;
  bottom: 3.5rem;
  right: 0.2rem;
  z-index: 10;
  .img-IT{
    width: 100%;
  }
  .img-icon{
    display: block;
    width: 0.3rem;
    height: 0.3rem;
    margin: 0.1rem auto 0;
  }
}
</style>